/* eslint-disable react/no-unescaped-entities */
import { NextSeo } from "next-seo";

import Banner from "lib/components/home/Banner";
import CTASection from "lib/components/home/CTASection";
import IntercomHelp from "lib/components/IntercomHelp";
import PricingCard from "lib/components/pricing/PricingCard";
import PricingHero from "lib/components/pricing/PricingHero";

const Pricing = () => {
  return (
    <>
      <NextSeo
        title="Pricing"
        description="Simple, affordable plans for satellite weather and safety alerts on your Garmin inReach, ZOLEO, or Bivy Stick. 14-day money-back guarantee."
      />
      <Banner />
      <PricingHero />
      <PricingCard />
      <CTASection />
      <IntercomHelp />
    </>
  );
};

export default Pricing;
